import { render, staticRenderFns } from "./RobloxUserIdArrayInput.vue?vue&type=template&id=6a08f9c6&"
import script from "./RobloxUserIdArrayInput.vue?vue&type=script&lang=js&"
export * from "./RobloxUserIdArrayInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports